import React from 'react';
import styled from 'styled-components';
import {
  ListBoxItem,
  ListText,
  ListTitle,
  ListSubtitle,
} from "../../../../assets/styles/BusinessAnalysisStyle";
import {
  Body1,
  Body2,
  Sub2,
} from "../../../../assets/styles/Typography";
import { CheckBoxButton } from "../../../../assets/styles/InputStyle";


const MoleculeMessageCard = ({ originalText, translatedText, isSelected, onSelect, id, disabled, FlexStart, onEdit, onEditComplete, isEditing, editId, setIsEditing }) => {

    const EditIcon = () => (
        <svg
          width="24"
          height="24"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.9124 4.12883C22.329 3.71227 23.0044 3.71227 23.4209 4.12883L28.7542 9.46216C28.9543 9.6622 29.0667 9.93351 29.0667 10.2164C29.0667 10.4993 28.9543 10.7706 28.7542 10.9707L16.7542 22.9707C16.5542 23.1707 16.2829 23.2831 16 23.2831H10.6667C10.0776 23.2831 9.6 22.8055 9.6 22.2164V16.8831C9.6 16.6002 9.71238 16.3289 9.91242 16.1288L21.9124 4.12883ZM22.6667 6.39157L20.1752 8.88307L24 12.7079L26.4915 10.2164L22.6667 6.39157ZM22.4915 14.2164L18.6667 10.3916L11.7333 17.3249V21.1497H15.5582L22.4915 14.2164ZM6.4 7.01641C6.25272 7.01641 6.13333 7.1358 6.13333 7.28307V26.4831C6.13333 26.6303 6.25272 26.7497 6.4 26.7497H25.6C25.7473 26.7497 25.8667 26.6303 25.8667 26.4831V17.1497C25.8667 16.5606 26.3442 16.0831 26.9333 16.0831C27.5224 16.0831 28 16.5606 28 17.1497V26.4831C28 27.8086 26.9255 28.8831 25.6 28.8831H6.4C5.07452 28.8831 4 27.8086 4 26.4831V7.28307C4 5.95759 5.07452 4.88307 6.4 4.88307H15.7323C16.3214 4.88307 16.799 5.36064 16.799 5.94974C16.799 6.53884 16.3214 7.01641 15.7323 7.01641H6.4Z"
            fill="#D1D5DB"
          />
        </svg>
      );
  return (
    <ListBoxItem Small NoBg selected={isSelected} active={isSelected} FlexStart={FlexStart} 
    style={{ 
        // marginBottom: '-26px',
        position: 'relative',
        padding: '16px',
        // marginBottom: '5px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        // width: editId === id ? '700px' : '100%',
      }}>
      <div style={{ marginRight: '0px' }}>
        <CheckBoxButton
          id={id}
          name={id}
          checked={isSelected}
          onChange={() => onSelect(id)}
          disabled={disabled}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <ListText style={{ flex: 1, width: "100%" }}>
        <ListTitle style={{ textAlign: "left" }}>
          {typeof translatedText === "string" ? (
            <Body1 color="gray800" align="left">
              {translatedText}
            </Body1>
          ) : (
            translatedText
          )}
        </ListTitle>
        {originalText && (
          <ListSubtitle style={{ textAlign: "left", marginTop: "4px" }}>
            {typeof originalText === "string" ? (
              <Body2 color="gray500">{originalText}</Body2>
            ) : (
              originalText
            )}
          </ListSubtitle>
        )}
      </ListText>
      {editId === id ? (
        <button
          style={{
            background: '#F4F8FF',
            color: '#256EF4',
            border: 'none',
            fontWeight: 600,
            fontSize: '14px',
            padding: '6px 16px',
            borderRadius: '8px',
            boxShadow: 'none',
            marginLeft: '8px',
            cursor: 'pointer',
          }}
          onClick={e => {
            e.stopPropagation();
            onEditComplete(id);
          }}
          tabIndex={-1}
        >
          편집 완료
        </button>
      ) : (
        <button
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            marginLeft: '8px',
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={e => {
            e.stopPropagation();
            onEdit(id);
          }}
          tabIndex={-1}
          aria-label="메시지 편집"
        >
          <EditIcon />
        </button>
      )}
    </ListBoxItem>
  );
};

export default MoleculeMessageCard; 
